<template>    
	<div class="container">
		<VUEConfirm :Popup="PopupEliminaUtente" :Richiesta="DescrPopupEliminaUtente" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'" @OnClickConfermaPopup="ConfermaElimina" @OnClickChiudiPopup="AnnullaElimina">
		</VUEConfirm>
		<div class="row">
			<div class="block">
				<div class="header" style="padding:0px"> 
					<div class="block block-transparent nm">
						<div class="content controls">
							<div class="form-row">                        
								<div class="col-md-5" style="padding-left:0px">
									<div class="input-group">
										<div class="input-group-addon"><span class="fa fa-search"></span></div>
										<input type="text" class="form-control" :placeholder="this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_CERCA_UTENTE',this.LinguaUtente)" v-model="FiltroUtente"/>
									</div>
								</div>
								<div class="col-md-2" style="float:right;padding-right:0px;">
									<button type="button" class="btn btn-success" @click="OnClickAggiungiProfilo" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente) }}</button>
								</div>
							</div>
						</div>
					</div>                                      
				</div>
				<div class="content">

					<table cellpadding="0" cellspacing="0" width="100%" class="table table-bordered table-striped sortable">
						<thead style="background-color:#60604d;color:white">
							<tr>
								<th width="4%"></th>
								<th width="15%">{{ this.GetTraduzioneLabel('Generic','TKN_USERNAME',this.LinguaUtente) }}</th>
								<th width="18%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_RAG_SOC',this.LinguaUtente) }}</th>
								<th width="13%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_RUOLO',this.LinguaUtente) }}</th>
								<th width="24%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_EMAIL',this.LinguaUtente) }}</th>                                    
								<th width="5%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_AZIONI',this.LinguaUtente) }}</th>
							</tr>
						</thead>
						<tbody :style="{'background-color' : Arancione}">
							<tr v-for="Utente in FiltroCerca" :Key="Utente.CHIAVE">
								<td>
									<img v-if="Utente.IMMAGINE"
										:src="Utente.IMMAGINE"
										style="width:40px; height:40px; margin-right:8px;border:1px solid rgba(255,255,255,0.3); border-radius:0" 
										class="img-circle img-thumbnail"/>
									<img v-else src="@/assets/images/avatar_default.jpg"
										style="width:40px; height:40px; margin-right:8px;background:white;border:1px solid rgba(255,255,255,0.3); border-radius:0" 
										class="img-circle img-thumbnail"/>
								</td>
								<td style="vertical-align:middle">{{Utente.USERNAME}}</td>
								<td style="vertical-align:middle">{{Utente.RAGIONE_SOCIALE}}</td>
								<td style="vertical-align:middle" v-if="Utente.ROLE == Ruoli.Amministratore">{{ this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_AMM_CSG',this.LinguaUtente) }}</td>
								<td style="vertical-align:middle" v-if="Utente.ROLE == Ruoli.Supervisore">{{ this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_SUP_CSG',this.LinguaUtente) }}</td>
								<td style="vertical-align:middle" v-if="Utente.ROLE == Ruoli.SuperUtente">{{ this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_SUPE',this.LinguaUtente) }}</td>
								<td style="vertical-align:middle" v-if="Utente.ROLE == Ruoli.Utente">{{ this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_UTENTE',this.LinguaUtente) }}</td>
								<td style="vertical-align:middle">{{Utente.EMAIL}}</td>                                     
								<td style="vertical-align:middle;text-align:center;">
									<div v-if="SelfUserName != Utente.USERNAME">
										<i class="fa fa-pencil text-warning ZMIconButton" @click="OnClickModificaProfilo(Utente)" style="margin-right:20px"></i>
										<i class="fa fa-trash-o text-danger ZMIconButton" @click="OnClickEliminaProfilo(Utente)"></i>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

			</div>
		</div>
	</div>
</template>


<script>
import { SystemInformation, RUOLI, SFONDO } from '@/SystemInformation.js'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import VUEConfirm from '@/utils/VUEConfirm.vue';

export default {
    name:'app',
    components: {
                   VUEConfirm
    },
    mixins: [ MixInsGestioneTraduzioni ],
    data()
    {
       return {
                ListaUtenti                   : [],
                FiltroUtente                  : '',
                Ruoli                         : RUOLI,
                Modello                       : '',
                PopupEliminaUtente            : false,
                ProfiloModifica               : {},
                DescrPopupEliminaUtente       : '',
                LinguaUtente                  : SystemInformation.UserInformation.Lingua,
                SelfUserName                  : SystemInformation.UserInformation.UserName,
                Arancione                     : SFONDO.Arancione
              }
    },
    methods :
    {
      ConfermaElimina()
      {
         var ObjQuery = { Operazioni: [] };
         var Self = this;
         ObjQuery.Operazioni.push({
                                     Query: "Delete",
                                     Parametri: {
                                                 CHIAVE              : Self.ProfiloModifica.CHIAVE
                                             }
                                 });
         SystemInformation.AdvQuery.PostSQL(this.Modello,ObjQuery,
                                             function()
                                             { 
                                                 Self.$router.go()
                                             },
                                             SystemInformation.HandleError)
         this.AnnullaElimina()
      },

      AnnullaElimina()
      {
         this.PopupEliminaUtente = false
      },

      OnClickAggiungiProfilo()
      {
        this.$router.push('/SchedaUtente/nuovo')
      },
      OnClickModificaProfilo(Profilo)
      {
        this.$router.push('/SchedaUtente/' + Profilo.CHIAVE)
      },
      OnClickEliminaProfilo(Profilo)
      {
         this.ProfiloModifica = Profilo
         this.PopupEliminaUtente = true
         this.DescrPopupEliminaUtente = this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_ALERT',this.LinguaUtente) + ' ' + Profilo.USERNAME + '?'
      },

      CaricaListaProfili()
      {
        var Self = this;
        SystemInformation.AdvQuery.GetSQL(this.Modello,{},
                                            function(Results)
                                            {
                                            let ArrayInfo = SystemInformation.AdvQuery.FindResults(Results,"Lista");
                                            if(ArrayInfo != undefined)
                                                Self.ListaUtenti = ArrayInfo;
                                            else SystemInformation.HandleError('Errore nel modello utenti'); 
                                            },
                                            SystemInformation.HandleError)
      },
    },
    computed :
    {
        FiltroCerca()
        {
            var Self = this;
            return this.ListaUtenti.filter(function(Utente) 
            {
                if(Self.FiltroUtente.trim() != '')  
                   if(!Utente.USERNAME.toUpperCase().match(Self.FiltroUtente.toUpperCase().trim()))
                      return false;
                return true;
            })
        }
    },
    beforeMount()
    {
       switch (SystemInformation.UserInformation.Ruolo)
       {
          case this.Ruoli.Amministratore : this.Modello = 'Admin_GestioneUtenti'
          break
          case this.Ruoli.SuperUtente    : this.Modello = 'SuperUtente_GestioneUtenti'
          break
          default                        : this.Modello = ''
       }
       this.CaricaListaProfili()
    }
}
</script>
